import { render, staticRenderFns } from "./RxBtn.vue?vue&type=template&id=52d1f77c&scoped=true"
import script from "./RxBtn.vue?vue&type=script&lang=js"
export * from "./RxBtn.vue?vue&type=script&lang=js"
import style0 from "./RxBtn.vue?vue&type=style&index=0&id=52d1f77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d1f77c",
  null
  
)

export default component.exports